import React from "react";
import DocFileUpload from "./docAdd/DocFileUpload";

export default function DocUploadForEsign({ setOpenDocUploadModal }) {
  return <DocFileUpload setOpenDocUploadModal={setOpenDocUploadModal} />;
}
